package com.eladfinish.bible.contest

import dev.icerock.moko.resources.StringResource
import dev.icerock.moko.resources.`internal`.SupportedLocale
import dev.icerock.moko.resources.`internal`.SupportedLocales
import dev.icerock.moko.resources.provider.RemoteJsStringLoader
import kotlin.String
import kotlin.collections.List

private val fallbackFileUrl: String =
    js("require(\"./localization/comeladfinishbiblecontest_stringsJson.json\")") as String

private val supportedLocales: SupportedLocales = SupportedLocales(listOf(
    SupportedLocale("de",
        js("require(\"./localization/comeladfinishbiblecontest_stringsJson_de.json\")") as String),
    SupportedLocale("en",
        js("require(\"./localization/comeladfinishbiblecontest_stringsJson_en.json\")") as String),
    SupportedLocale("es",
        js("require(\"./localization/comeladfinishbiblecontest_stringsJson_es.json\")") as String),
    SupportedLocale("fr",
        js("require(\"./localization/comeladfinishbiblecontest_stringsJson_fr.json\")") as String),
    SupportedLocale("ru",
        js("require(\"./localization/comeladfinishbiblecontest_stringsJson_ru.json\")") as String),
    ))

private val stringsLoader: RemoteJsStringLoader = RemoteJsStringLoader.Impl(supportedLocales =
    supportedLocales, fallbackFileUri = fallbackFileUrl)

internal object CommonMainStrings9 {
  internal val save_content_in_file: StringResource by lazy { init_save_content_in_file() }

  internal val save_custom_mikud: StringResource by lazy { init_save_custom_mikud() }

  internal val save_mikud: StringResource by lazy { init_save_mikud() }

  internal val save_nikud_and_teamim: StringResource by lazy { init_save_nikud_and_teamim() }

  internal val save_to_file: StringResource by lazy { init_save_to_file() }

  internal val saved_completions: StringResource by lazy { init_saved_completions() }

  internal val screen_misc: StringResource by lazy { init_screen_misc() }

  internal val screen_names_in_bible: StringResource by lazy { init_screen_names_in_bible() }

  internal val scroll_down: StringResource by lazy { init_scroll_down() }

  internal val search: StringResource by lazy { init_search() }

  internal val search_ai: StringResource by lazy { init_search_ai() }

  internal val search_ai_emojis: StringResource by lazy { init_search_ai_emojis() }

  internal val search_box_is_empty: StringResource by lazy { init_search_box_is_empty() }

  internal val search_expression: StringResource by lazy { init_search_expression() }

  internal val search_has_been_interrupted: StringResource by lazy {
      init_search_has_been_interrupted() }

  internal val search_has_ended: StringResource by lazy { init_search_has_ended() }

  internal val search_history: StringResource by lazy { init_search_history() }

  internal val search_history_clear_all: StringResource by lazy { init_search_history_clear_all() }

  internal val search_history_clear_confirm_message: StringResource by lazy {
      init_search_history_clear_confirm_message() }

  internal val search_history_clear_confirm_title: StringResource by lazy {
      init_search_history_clear_confirm_title() }

  internal val search_history_delete_entry: StringResource by lazy {
      init_search_history_delete_entry() }

  internal val search_history_empty: StringResource by lazy { init_search_history_empty() }

  internal val search_history_most_searched: StringResource by lazy {
      init_search_history_most_searched() }

  internal val search_history_recent: StringResource by lazy { init_search_history_recent() }

  internal val search_history_saved_hint: StringResource by lazy { init_search_history_saved_hint()
      }

  internal val search_history_show: StringResource by lazy { init_search_history_show() }

  internal val search_history_without_nikud: StringResource by lazy {
      init_search_history_without_nikud() }

  internal val search_history_without_teamim: StringResource by lazy {
      init_search_history_without_teamim() }

  internal val search_in_bible: StringResource by lazy { init_search_in_bible() }

  internal val search_in_bible_new: StringResource by lazy { init_search_in_bible_new() }

  internal val search_instruction_for_number: StringResource by lazy {
      init_search_instruction_for_number() }

  internal val search_instruction_for_number_format: StringResource by lazy {
      init_search_instruction_for_number_format() }

  internal val search_instruction_for_word_boundary: StringResource by lazy {
      init_search_instruction_for_word_boundary() }

  internal val search_instruction_for_word_boundary_format: StringResource by lazy {
      init_search_instruction_for_word_boundary_format() }

  internal val search_mode: StringResource by lazy { init_search_mode() }

  internal val search_mode_placeholder: StringResource by lazy { init_search_mode_placeholder() }

  internal val search_place: StringResource by lazy { init_search_place() }

  internal val search_place_placeholder: StringResource by lazy { init_search_place_placeholder() }

  internal val search_popular_searches: StringResource by lazy { init_search_popular_searches() }

  internal val search_popular_searches_all_time: StringResource by lazy {
      init_search_popular_searches_all_time() }

  internal val search_popular_searches_hint: StringResource by lazy {
      init_search_popular_searches_hint() }

  internal val search_popular_searches_mine: StringResource by lazy {
      init_search_popular_searches_mine() }

  internal val search_popular_searches_title_format: StringResource by lazy {
      init_search_popular_searches_title_format() }

  internal val search_progress_format: StringResource by lazy { init_search_progress_format() }

  internal val search_progress_special_search_format: StringResource by lazy {
      init_search_progress_special_search_format() }

  internal val search_regex: StringResource by lazy { init_search_regex() }

  internal val search_report: StringResource by lazy { init_search_report() }

  internal val search_results: StringResource by lazy { init_search_results() }

  internal val search_results_by_book_title: StringResource by lazy {
      init_search_results_by_book_title() }

  internal val search_results_placeholder: StringResource by lazy {
      init_search_results_placeholder() }

  internal fun values(): List<StringResource> = listOf(save_content_in_file, save_custom_mikud,
      save_mikud, save_nikud_and_teamim, save_to_file, saved_completions, screen_misc,
      screen_names_in_bible, scroll_down, search, search_ai, search_ai_emojis, search_box_is_empty,
      search_expression, search_has_been_interrupted, search_has_ended, search_history,
      search_history_clear_all, search_history_clear_confirm_message,
      search_history_clear_confirm_title, search_history_delete_entry, search_history_empty,
      search_history_most_searched, search_history_recent, search_history_saved_hint,
      search_history_show, search_history_without_nikud, search_history_without_teamim,
      search_in_bible, search_in_bible_new, search_instruction_for_number,
      search_instruction_for_number_format, search_instruction_for_word_boundary,
      search_instruction_for_word_boundary_format, search_mode, search_mode_placeholder,
      search_place, search_place_placeholder, search_popular_searches,
      search_popular_searches_all_time, search_popular_searches_hint, search_popular_searches_mine,
      search_popular_searches_title_format, search_progress_format,
      search_progress_special_search_format, search_regex, search_report, search_results,
      search_results_by_book_title, search_results_placeholder)
}

private fun init_save_content_in_file(): StringResource = StringResource(key =
    "save_content_in_file", loader = stringsLoader)

private fun init_save_custom_mikud(): StringResource = StringResource(key = "save_custom_mikud",
    loader = stringsLoader)

private fun init_save_mikud(): StringResource = StringResource(key = "save_mikud", loader =
    stringsLoader)

private fun init_save_nikud_and_teamim(): StringResource = StringResource(key =
    "save_nikud_and_teamim", loader = stringsLoader)

private fun init_save_to_file(): StringResource = StringResource(key = "save_to_file", loader =
    stringsLoader)

private fun init_saved_completions(): StringResource = StringResource(key = "saved_completions",
    loader = stringsLoader)

private fun init_screen_misc(): StringResource = StringResource(key = "screen_misc", loader =
    stringsLoader)

private fun init_screen_names_in_bible(): StringResource = StringResource(key =
    "screen_names_in_bible", loader = stringsLoader)

private fun init_scroll_down(): StringResource = StringResource(key = "scroll_down", loader =
    stringsLoader)

private fun init_search(): StringResource = StringResource(key = "search", loader = stringsLoader)

private fun init_search_ai(): StringResource = StringResource(key = "search_ai", loader =
    stringsLoader)

private fun init_search_ai_emojis(): StringResource = StringResource(key = "search_ai_emojis",
    loader = stringsLoader)

private fun init_search_box_is_empty(): StringResource = StringResource(key = "search_box_is_empty",
    loader = stringsLoader)

private fun init_search_expression(): StringResource = StringResource(key = "search_expression",
    loader = stringsLoader)

private fun init_search_has_been_interrupted(): StringResource = StringResource(key =
    "search_has_been_interrupted", loader = stringsLoader)

private fun init_search_has_ended(): StringResource = StringResource(key = "search_has_ended",
    loader = stringsLoader)

private fun init_search_history(): StringResource = StringResource(key = "search_history", loader =
    stringsLoader)

private fun init_search_history_clear_all(): StringResource = StringResource(key =
    "search_history_clear_all", loader = stringsLoader)

private fun init_search_history_clear_confirm_message(): StringResource = StringResource(key =
    "search_history_clear_confirm_message", loader = stringsLoader)

private fun init_search_history_clear_confirm_title(): StringResource = StringResource(key =
    "search_history_clear_confirm_title", loader = stringsLoader)

private fun init_search_history_delete_entry(): StringResource = StringResource(key =
    "search_history_delete_entry", loader = stringsLoader)

private fun init_search_history_empty(): StringResource = StringResource(key =
    "search_history_empty", loader = stringsLoader)

private fun init_search_history_most_searched(): StringResource = StringResource(key =
    "search_history_most_searched", loader = stringsLoader)

private fun init_search_history_recent(): StringResource = StringResource(key =
    "search_history_recent", loader = stringsLoader)

private fun init_search_history_saved_hint(): StringResource = StringResource(key =
    "search_history_saved_hint", loader = stringsLoader)

private fun init_search_history_show(): StringResource = StringResource(key = "search_history_show",
    loader = stringsLoader)

private fun init_search_history_without_nikud(): StringResource = StringResource(key =
    "search_history_without_nikud", loader = stringsLoader)

private fun init_search_history_without_teamim(): StringResource = StringResource(key =
    "search_history_without_teamim", loader = stringsLoader)

private fun init_search_in_bible(): StringResource = StringResource(key = "search_in_bible", loader
    = stringsLoader)

private fun init_search_in_bible_new(): StringResource = StringResource(key = "search_in_bible_new",
    loader = stringsLoader)

private fun init_search_instruction_for_number(): StringResource = StringResource(key =
    "search_instruction_for_number", loader = stringsLoader)

private fun init_search_instruction_for_number_format(): StringResource = StringResource(key =
    "search_instruction_for_number_format", loader = stringsLoader)

private fun init_search_instruction_for_word_boundary(): StringResource = StringResource(key =
    "search_instruction_for_word_boundary", loader = stringsLoader)

private fun init_search_instruction_for_word_boundary_format(): StringResource = StringResource(key
    = "search_instruction_for_word_boundary_format", loader = stringsLoader)

private fun init_search_mode(): StringResource = StringResource(key = "search_mode", loader =
    stringsLoader)

private fun init_search_mode_placeholder(): StringResource = StringResource(key =
    "search_mode_placeholder", loader = stringsLoader)

private fun init_search_place(): StringResource = StringResource(key = "search_place", loader =
    stringsLoader)

private fun init_search_place_placeholder(): StringResource = StringResource(key =
    "search_place_placeholder", loader = stringsLoader)

private fun init_search_popular_searches(): StringResource = StringResource(key =
    "search_popular_searches", loader = stringsLoader)

private fun init_search_popular_searches_all_time(): StringResource = StringResource(key =
    "search_popular_searches_all_time", loader = stringsLoader)

private fun init_search_popular_searches_hint(): StringResource = StringResource(key =
    "search_popular_searches_hint", loader = stringsLoader)

private fun init_search_popular_searches_mine(): StringResource = StringResource(key =
    "search_popular_searches_mine", loader = stringsLoader)

private fun init_search_popular_searches_title_format(): StringResource = StringResource(key =
    "search_popular_searches_title_format", loader = stringsLoader)

private fun init_search_progress_format(): StringResource = StringResource(key =
    "search_progress_format", loader = stringsLoader)

private fun init_search_progress_special_search_format(): StringResource = StringResource(key =
    "search_progress_special_search_format", loader = stringsLoader)

private fun init_search_regex(): StringResource = StringResource(key = "search_regex", loader =
    stringsLoader)

private fun init_search_report(): StringResource = StringResource(key = "search_report", loader =
    stringsLoader)

private fun init_search_results(): StringResource = StringResource(key = "search_results", loader =
    stringsLoader)

private fun init_search_results_by_book_title(): StringResource = StringResource(key =
    "search_results_by_book_title", loader = stringsLoader)

private fun init_search_results_placeholder(): StringResource = StringResource(key =
    "search_results_placeholder", loader = stringsLoader)

public actual val SharedRes.strings.save_content_in_file: StringResource
  get() = CommonMainStrings9.save_content_in_file

public actual val SharedRes.strings.save_custom_mikud: StringResource
  get() = CommonMainStrings9.save_custom_mikud

public actual val SharedRes.strings.save_mikud: StringResource
  get() = CommonMainStrings9.save_mikud

public actual val SharedRes.strings.save_nikud_and_teamim: StringResource
  get() = CommonMainStrings9.save_nikud_and_teamim

public actual val SharedRes.strings.save_to_file: StringResource
  get() = CommonMainStrings9.save_to_file

public actual val SharedRes.strings.saved_completions: StringResource
  get() = CommonMainStrings9.saved_completions

public actual val SharedRes.strings.screen_misc: StringResource
  get() = CommonMainStrings9.screen_misc

public actual val SharedRes.strings.screen_names_in_bible: StringResource
  get() = CommonMainStrings9.screen_names_in_bible

public actual val SharedRes.strings.scroll_down: StringResource
  get() = CommonMainStrings9.scroll_down

public actual val SharedRes.strings.search: StringResource
  get() = CommonMainStrings9.search

public actual val SharedRes.strings.search_ai: StringResource
  get() = CommonMainStrings9.search_ai

public actual val SharedRes.strings.search_ai_emojis: StringResource
  get() = CommonMainStrings9.search_ai_emojis

public actual val SharedRes.strings.search_box_is_empty: StringResource
  get() = CommonMainStrings9.search_box_is_empty

public actual val SharedRes.strings.search_expression: StringResource
  get() = CommonMainStrings9.search_expression

public actual val SharedRes.strings.search_has_been_interrupted: StringResource
  get() = CommonMainStrings9.search_has_been_interrupted

public actual val SharedRes.strings.search_has_ended: StringResource
  get() = CommonMainStrings9.search_has_ended

public actual val SharedRes.strings.search_history: StringResource
  get() = CommonMainStrings9.search_history

public actual val SharedRes.strings.search_history_clear_all: StringResource
  get() = CommonMainStrings9.search_history_clear_all

public actual val SharedRes.strings.search_history_clear_confirm_message: StringResource
  get() = CommonMainStrings9.search_history_clear_confirm_message

public actual val SharedRes.strings.search_history_clear_confirm_title: StringResource
  get() = CommonMainStrings9.search_history_clear_confirm_title

public actual val SharedRes.strings.search_history_delete_entry: StringResource
  get() = CommonMainStrings9.search_history_delete_entry

public actual val SharedRes.strings.search_history_empty: StringResource
  get() = CommonMainStrings9.search_history_empty

public actual val SharedRes.strings.search_history_most_searched: StringResource
  get() = CommonMainStrings9.search_history_most_searched

public actual val SharedRes.strings.search_history_recent: StringResource
  get() = CommonMainStrings9.search_history_recent

public actual val SharedRes.strings.search_history_saved_hint: StringResource
  get() = CommonMainStrings9.search_history_saved_hint

public actual val SharedRes.strings.search_history_show: StringResource
  get() = CommonMainStrings9.search_history_show

public actual val SharedRes.strings.search_history_without_nikud: StringResource
  get() = CommonMainStrings9.search_history_without_nikud

public actual val SharedRes.strings.search_history_without_teamim: StringResource
  get() = CommonMainStrings9.search_history_without_teamim

public actual val SharedRes.strings.search_in_bible: StringResource
  get() = CommonMainStrings9.search_in_bible

public actual val SharedRes.strings.search_in_bible_new: StringResource
  get() = CommonMainStrings9.search_in_bible_new

public actual val SharedRes.strings.search_instruction_for_number: StringResource
  get() = CommonMainStrings9.search_instruction_for_number

public actual val SharedRes.strings.search_instruction_for_number_format: StringResource
  get() = CommonMainStrings9.search_instruction_for_number_format

public actual val SharedRes.strings.search_instruction_for_word_boundary: StringResource
  get() = CommonMainStrings9.search_instruction_for_word_boundary

public actual val SharedRes.strings.search_instruction_for_word_boundary_format: StringResource
  get() = CommonMainStrings9.search_instruction_for_word_boundary_format

public actual val SharedRes.strings.search_mode: StringResource
  get() = CommonMainStrings9.search_mode

public actual val SharedRes.strings.search_mode_placeholder: StringResource
  get() = CommonMainStrings9.search_mode_placeholder

public actual val SharedRes.strings.search_place: StringResource
  get() = CommonMainStrings9.search_place

public actual val SharedRes.strings.search_place_placeholder: StringResource
  get() = CommonMainStrings9.search_place_placeholder

public actual val SharedRes.strings.search_popular_searches: StringResource
  get() = CommonMainStrings9.search_popular_searches

public actual val SharedRes.strings.search_popular_searches_all_time: StringResource
  get() = CommonMainStrings9.search_popular_searches_all_time

public actual val SharedRes.strings.search_popular_searches_hint: StringResource
  get() = CommonMainStrings9.search_popular_searches_hint

public actual val SharedRes.strings.search_popular_searches_mine: StringResource
  get() = CommonMainStrings9.search_popular_searches_mine

public actual val SharedRes.strings.search_popular_searches_title_format: StringResource
  get() = CommonMainStrings9.search_popular_searches_title_format

public actual val SharedRes.strings.search_progress_format: StringResource
  get() = CommonMainStrings9.search_progress_format

public actual val SharedRes.strings.search_progress_special_search_format: StringResource
  get() = CommonMainStrings9.search_progress_special_search_format

public actual val SharedRes.strings.search_regex: StringResource
  get() = CommonMainStrings9.search_regex

public actual val SharedRes.strings.search_report: StringResource
  get() = CommonMainStrings9.search_report

public actual val SharedRes.strings.search_results: StringResource
  get() = CommonMainStrings9.search_results

public actual val SharedRes.strings.search_results_by_book_title: StringResource
  get() = CommonMainStrings9.search_results_by_book_title

public actual val SharedRes.strings.search_results_placeholder: StringResource
  get() = CommonMainStrings9.search_results_placeholder
